module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "videoreview"
    }
  }, [_c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "lists",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "500"
    }
  }, _vm._l((_vm.breakPoints), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list",
      on: {
        "click": function($event) {
          return _vm.onPlay(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "stop",
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.create_time))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d479d24"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/special.vue
// module id = 269
// module chunks = 0